import React, { useCallback, useEffect, useState, useRef } from 'react';
// redux
import { connect } from 'react-redux';
// selecor
import { createStructuredSelector } from 'reselect';
import { getJournalList, getTagList, getUI, getFilters } from 'redux/selectors';
import * as JournalActions from 'redux/actions/journal';
// Actions
import { updateUI } from 'redux/actions/ui';

// icons
import iconCaretDown from 'assets/images/icons_svg/icon_caret-down.svg';
import iconCheckSm from 'assets/images/icons_svg/icon_check-sm.svg';

const JournalSelectStep = ({
    display,
    journals,
    ui,
    dispatch,
    tags,
    filters
}) => {
    const {
        book_extra_journals = [],
        book_tags = [],
        book_chapters = [],
        book_mission_journals = [],
        book_select_journal = true
    } = ui;

    // Detect mission journal from active filter
    // const activeJournal = filters?.filterByJournal?.[0] || null;
    // const isMissionJournal =
    //     activeJournal &&
    //     (activeJournal.journal_type === 'Mission' ||
    //         activeJournal.is_mission ||
    //         activeJournal.missionjrnl_id);

    const [chapters, setChapters] = useState([]);
    const [openChaptersDrop, setOpenChaptersDrop] = useState(false);
    const toggleChaptersDrop = useCallback(() => {
        setOpenChaptersDrop(!openChaptersDrop);
    }, [openChaptersDrop]);

    // Fetch ALL chapters across all journals on mount
    useEffect(() => {
        dispatch(JournalActions.fetchAllChapters()).then((res) => {
            const results = res?.payload?.data?.results || [];
            setChapters(
                results.map((ch) => ({
                    id: ch.id,
                    name: ch.chapter_name,
                    start_date: ch.start_date,
                    end_date: ch.end_date,
                    journal_id: ch.journal_id,
                    resource_uri: ch.resource_uri,
                    merged_from_display_name: ch.merged_from_display_name
                }))
            );
        });
    }, [dispatch]);

    const [openJournalsDrop, setOpenJournalsDrop] = useState(false);
    const [openTagsDrop, setOpenTagsDrop] = useState(false);
    const toggleJournalsDrop = useCallback(() => {
        setOpenJournalsDrop(!openJournalsDrop);
    }, [openJournalsDrop]);
    const toggleTagsDrop = useCallback(() => {
        setOpenTagsDrop(!openTagsDrop);
    }, [openTagsDrop]);

    const journalsDropRef = useRef(null);
    const tagsDropRef = useRef(null);
    const chaptersDropRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                journalsDropRef.current &&
                !journalsDropRef.current.contains(event.target)
            ) {
                setOpenJournalsDrop(false);
            }
            if (
                tagsDropRef.current &&
                !tagsDropRef.current.contains(event.target)
            ) {
                setOpenTagsDrop(false);
            }
            if (
                chaptersDropRef.current &&
                !chaptersDropRef.current.contains(event.target)
            ) {
                setOpenChaptersDrop(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        dispatch(
            updateUI({
                book_extra_journals: [],
                book_tags: [],
                book_chapters: [],
                book_mission_journals: []
            })
        );
    }, [dispatch]);
    const changeJournalStatus = useCallback(
        (journal, status) => {
            const newBookJournals = [...book_extra_journals];
            if (status === true) {
                newBookJournals.push(journal);
            } else {
                const index = newBookJournals.findIndex(
                    (item) => item.id === journal.id
                );
                newBookJournals.splice(index, 1);
            }

            dispatch(
                updateUI({
                    book_extra_journals: newBookJournals
                })
            );
        },
        [dispatch, book_extra_journals]
    );

    const changeTagStatus = useCallback(
        (tag, status) => {
            const newTags = [...book_tags];
            if (status === true) {
                newTags.push(tag);
            } else {
                const index = newTags.findIndex((item) => item.id === tag.id);
                newTags.splice(index, 1);
            }

            dispatch(
                updateUI({
                    book_tags: newTags
                })
            );
        },
        [dispatch, book_tags]
    );

    const changeMissionJournalStatus = useCallback(
        (journal, status) => {
            const newMissionJournals = [...book_mission_journals];
            if (status === true) {
                newMissionJournals.push(journal);
            } else {
                const index = newMissionJournals.findIndex(
                    (item) => item.id === journal.id
                );
                newMissionJournals.splice(index, 1);
            }

            dispatch(
                updateUI({
                    book_mission_journals: newMissionJournals
                })
            );
        },
        [dispatch, book_mission_journals]
    );

    const renderJournalsDropdownName = useCallback(() => {
        if (book_extra_journals.length === 0) {
            return 'Select Journals';
        }
        return book_extra_journals
            .map((item) => {
                const journal = (journals?.journals || []).find(
                    (journal) => item.id === journal.id
                );

                return journal?.title;
            })
            .join(', ');
    }, [book_extra_journals, journals]);

    const renderTagsDropdownName = useCallback(() => {
        if (book_tags.length === 0) {
            return 'Select Tags';
        }
        return book_tags
            .map((item) => {
                const tag = (tags?.tags || []).find(
                    (tag) => item.id === tag.id
                );
                return tag?.name;
            })
            .join(', ');
    }, [book_tags, tags]);

    const renderMissionJournalsDropdownName = useCallback(() => {
        if (book_mission_journals.length === 0) {
            return 'Select Mission Journals';
        }
        return book_mission_journals
            .map((item) => {
                const journal = (journals?.journals || []).find(
                    (journal) => item.id === journal.id
                );

                return journal?.title;
            })
            .join(', ');
    }, [book_mission_journals, journals]);

    const changeChapterStatus = useCallback(
        (chapter, status) => {
            const newChapters = [...book_chapters];
            if (status === true) {
                newChapters.push(chapter);
            } else {
                const index = newChapters.findIndex(
                    (item) => item.id === chapter.id
                );
                newChapters.splice(index, 1);
            }
            dispatch(updateUI({ book_chapters: newChapters }));
        },
        [dispatch, book_chapters]
    );

    const renderChaptersDropdownName = useCallback(() => {
        if (book_chapters.length === 0) {
            return 'Select Chapters';
        }
        return book_chapters
            .map((item) => {
                const chapter = chapters.find((ch) => ch.id === item.id);
                return chapter ? chapter.name : item.name;
            })
            .filter(Boolean)
            .join(', ');
    }, [book_chapters, chapters]);

    const isMissionJournal = useCallback((journal) => {
        return (
            journal?.journal_type === 'Mission' ||
            journal?.is_mission === true ||
            (journal?.missionjrnl_id && journal?.missionjrnl_id !== '')
        );
    }, []);

    const renderChapterItem = useCallback(
        (chapter) => {
            const active =
                book_chapters.findIndex((item) => item.id === chapter.id) >= 0;
            return (
                <li
                    key={`chapter-list-${chapter.id}`}
                    onClick={() => changeChapterStatus(chapter, !active)}
                    className={`${active ? 'active' : ''}`}>
                    <div className="dropdown-selected-list__check">
                        <img src={iconCheckSm} alt="" />
                    </div>
                    <div className="dropdown-selected-list__title truncate">
                        <span>{chapter.name}</span>
                        {chapter.merged_from_display_name && (
                            <span
                                style={{
                                    display: 'block',
                                    fontSize: '11px',
                                    color: '#6b6b6b',
                                    marginTop: '2px'
                                }}>
                                Merged from: {chapter.merged_from_display_name}
                            </span>
                        )}
                    </div>
                </li>
            );
        },
        [book_chapters, changeChapterStatus]
    );

    const renderMissionJournalItem = useCallback(
        (journal) => {
            const active =
                book_mission_journals.findIndex(
                    (item) => item.id === journal.id
                ) >= 0;
            return (
                <li
                    key={`mission-journal-list-${journal.id}`}
                    onClick={() => changeMissionJournalStatus(journal, !active)}
                    className={`${active ? 'active' : ''}`}>
                    <div className="dropdown-selected-list__check">
                        <img src={iconCheckSm} alt="" />
                    </div>
                    <div className="dropdown-selected-list__title truncate">
                        <span>
                            {journal.title} ({journal.entry_count} entr
                            {journal.entry_count > 1 ? 'ies' : 'y'})
                        </span>
                    </div>
                </li>
            );
        },
        [book_mission_journals, changeMissionJournalStatus]
    );

    const changeBookSelect = useCallback(
        (status) => {
            dispatch(
                updateUI({
                    book_select_journal: status
                })
            );
        },
        [dispatch]
    );

    const renderJournalItem = useCallback(
        (journal) => {
            const active =
                book_extra_journals.findIndex(
                    (item) => item.id === journal.id
                ) >= 0;
            return (
                <li
                    key={`journal-list-${journal.id}`}
                    onClick={() => changeJournalStatus(journal, !active)}
                    className={`${active ? 'active' : ''}`}>
                    <div className="dropdown-selected-list__check">
                        <img src={iconCheckSm} alt="" />
                    </div>
                    <div className="dropdown-selected-list__title truncate">
                        <span>
                            {journal.title} ({journal.entry_count} entr
                            {journal.entry_count > 1 ? 'ies' : 'y'})
                        </span>
                    </div>
                </li>
            );
        },
        [book_extra_journals, changeJournalStatus]
    );

    const renderTagItem = useCallback(
        (tag) => {
            const active =
                book_tags.findIndex((item) => item.id === tag.id) >= 0;
            return (
                <li
                    key={`tag-list-${tag.id}`}
                    onClick={() => changeTagStatus(tag, !active)}
                    className={`${active ? 'active' : ''}`}>
                    <div className="dropdown-selected-list__check">
                        <img src={iconCheckSm} alt="" />
                    </div>
                    <div className="dropdown-selected-list__title truncate">
                        <span>{tag.name}</span>
                    </div>
                </li>
            );
        },
        [book_tags, changeTagStatus]
    );

    useEffect(() => {
        if (display === true) {
            dispatch(
                updateUI({
                    canGoNext:
                        (book_select_journal === true &&
                            book_extra_journals.length > 0) ||
                        (book_select_journal === false &&
                            book_tags.length > 0) ||
                        (book_select_journal === 'chapters' &&
                            book_chapters.length > 0) ||
                        (book_select_journal === 'mission_chapters' &&
                            book_mission_journals.length > 0)
                })
            );
        }
    }, [
        display,
        dispatch,
        book_select_journal,
        book_extra_journals.length,
        book_tags.length,
        book_chapters.length,
        book_mission_journals.length
    ]);
    useEffect(() => {
        if (display) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [display]);

    return (
        <div
            className={`new-book-step-2 new-book-step ${
                display ? 'active-form' : ''
            }`}>
            <div className="section-title">Journal</div>
            <div className="new-book-step-form">
                <p>Choose which journal or tag to include entries from</p>
                <div>
                    <div className="form-group">
                        <div className="radio-item">
                            <input
                                onClick={() => changeBookSelect(true)}
                                onChange={() => {}}
                                className="radio"
                                type="radio"
                                id="printJournals"
                                name="print-options"
                                value="0"
                                checked={book_select_journal === true}
                            />
                            <label htmlFor="printJournals">
                                Print from your Journals
                            </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="radio-item">
                            <input
                                onClick={() => changeBookSelect(false)}
                                onChange={() => {}}
                                className="radio"
                                type="radio"
                                id="printEntries"
                                name="print-options"
                                value="1"
                                checked={book_select_journal === false}
                            />
                            <label htmlFor="printEntries">
                                Print from your Tags
                            </label>
                        </div>
                    </div>
                    {/* ── Chapters option — always visible ── */}
                    <div className="form-group">
                        <div className="radio-item">
                            <input
                                onClick={() => changeBookSelect('chapters')}
                                onChange={() => {}}
                                className="radio"
                                type="radio"
                                id="printChapters"
                                name="print-options"
                                value="2"
                                checked={book_select_journal === 'chapters'}
                            />
                            <label htmlFor="printChapters">
                                Print from your Journal Chapters
                            </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <div className="radio-item">
                            <input
                                onClick={() =>
                                    changeBookSelect('mission_chapters')
                                }
                                onChange={() => {}}
                                className="radio"
                                type="radio"
                                id="printMissionChapters"
                                name="print-options"
                                value="3"
                                checked={
                                    book_select_journal === 'mission_chapters'
                                }
                            />
                            <label htmlFor="printMissionChapters">
                                Print from your Mission Journal with chapters
                            </label>
                        </div>
                    </div>
                    <div className="form-group">
                        {book_select_journal === true ? (
                            <div className="form-group__item p-0">
                                <div className="section-title">
                                    Selected Journals
                                </div>
                                <div
                                    ref={journalsDropRef}
                                    id="journal-tags-wrapper"
                                    className="dropdown show">
                                    <div
                                        onClick={toggleJournalsDrop}
                                        className="form-group__select dropdown-toggle truncate"
                                        role="button"
                                        aria-disabled={true}
                                        id="selectedTagsModal"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span>
                                            {renderJournalsDropdownName()}
                                        </span>
                                        <img src={iconCaretDown} alt="" />
                                    </div>
                                    <div
                                        className={`dropdown-menu max-height--400 scrollable ${
                                            openJournalsDrop ? 'show' : ''
                                        }`}
                                        aria-labelledby="selectedJournalsModal">
                                        <ul className="dropdown-selected-list">
                                            {(journals?.journals || [])
                                                .filter(
                                                    (j) =>
                                                        j.title !==
                                                        'All About Me'
                                                )
                                                .map((journal) =>
                                                    renderJournalItem(journal)
                                                )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : book_select_journal === 'chapters' ? (
                            <div className="form-group__item p-0">
                                <div className="section-title">
                                    Selected Chapters
                                </div>
                                <div
                                    ref={chaptersDropRef}
                                    id="journal-chapters-wrapper"
                                    className="dropdown show">
                                    <div
                                        className="form-group__select dropdown-toggle truncate"
                                        role="button"
                                        id="selectedChaptersModal"
                                        onClick={toggleChaptersDrop}
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span>
                                            {renderChaptersDropdownName()}
                                        </span>
                                        <img src={iconCaretDown} alt="" />
                                    </div>
                                    <div
                                        className={`dropdown-menu max-height--400 scrollable ${
                                            openChaptersDrop ? 'show' : ''
                                        }`}
                                        aria-labelledby="selectedChaptersModal">
                                        <ul className="dropdown-selected-list">
                                            {chapters.length > 0 ? (
                                                chapters.map((ch) =>
                                                    renderChapterItem(ch)
                                                )
                                            ) : (
                                                <p
                                                    style={{
                                                        padding: '8px 12px',
                                                        color: '#999'
                                                    }}>
                                                    No chapters found. Add
                                                    chapters via Journal
                                                    Settings.
                                                </p>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : book_select_journal === 'mission_chapters' ? (
                            <div className="form-group__item p-0">
                                <div className="section-title">
                                    Selected Mission Journals
                                </div>
                                <div
                                    ref={journalsDropRef}
                                    id="mission-journal-wrapper"
                                    className="dropdown show">
                                    <div
                                        onClick={toggleJournalsDrop}
                                        className="form-group__select dropdown-toggle truncate"
                                        role="button"
                                        aria-disabled={true}
                                        id="selectedMissionJournalsModal"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span>
                                            {renderMissionJournalsDropdownName()}
                                        </span>
                                        <img src={iconCaretDown} alt="" />
                                    </div>
                                    <div
                                        className={`dropdown-menu max-height--400 scrollable ${
                                            openJournalsDrop ? 'show' : ''
                                        }`}
                                        aria-labelledby="selectedMissionJournalsModal">
                                        <ul className="dropdown-selected-list">
                                            {(journals?.journals || [])
                                                .filter(
                                                    (j) =>
                                                        j.title !==
                                                        'All About Me'
                                                )
                                                .filter((j) =>
                                                    isMissionJournal(j)
                                                )
                                                .map((journal) =>
                                                    renderMissionJournalItem(
                                                        journal
                                                    )
                                                )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="form-group__item p-0">
                                <div className="section-title">
                                    Selected Tags
                                </div>
                                <div
                                    ref={tagsDropRef}
                                    id="journal-tags-wrapper"
                                    className="dropdown show">
                                    <div
                                        className="form-group__select dropdown-toggle truncate"
                                        role="button"
                                        id="selectedTagsModal"
                                        onClick={toggleTagsDrop}
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span>{renderTagsDropdownName()}</span>
                                        <img src={iconCaretDown} alt="" />
                                    </div>
                                    <div
                                        className={`dropdown-menu max-height--400 scrollable ${
                                            openTagsDrop ? 'show' : ''
                                        }`}
                                        aria-labelledby="selectedTagsModal">
                                        <ul className="dropdown-selected-list">
                                            {tags?.tags?.length > 0 ? (
                                                tags?.tags
                                                    .filter((tag) => {
                                                        return (
                                                            tag.entry_count !==
                                                            0
                                                        );
                                                    })
                                                    .map((tag) =>
                                                        renderTagItem(tag)
                                                    )
                                            ) : (
                                                <p>No tags found</p>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const state = createStructuredSelector({
    journals: getJournalList,
    tags: getTagList,
    ui: getUI,
    filters: getFilters
});
export default connect(state)(JournalSelectStep);
